import { DependencyInjector } from '~/injector/clientDependencyInjector'
import { CardApiServiceInterface } from '~/modules/Cards/Domain/CardApiServiceInterface'
import { SignatureServiceInterface } from '~/modules/Products/Domain/SignatureServiceInterface'
import { SignableRequest } from '~/modules/Products/Domain/SignableRequest'
import { AnalyticsServiceInterface } from '~/modules/Analytics/Domain/AnalyticsServiceInterface'
import { MintCardResponseDto } from '~/modules/Cards/Mint/Application/MintCardResponseDto'
import chain from '~/modules/Chains/Domain/ChainProvider'
import { APIError } from '~/types/ApiException'

/**
 * Client-side implementation to call HTTP card API endpoints
 */
export class HttpCardApiService implements CardApiServiceInterface {
  // eslint-disable-next-line no-useless-constructor
  constructor (private analyticService: AnalyticsServiceInterface) {}
  /**
   * Call HTTP endpoint to mint a card
   * @param mintRequest NFT id of card to be minted
   */
  async mint (mintRequest: SignableRequest): Promise<void> {
    const signatureService: SignatureServiceInterface =
      DependencyInjector.getInstance().resolve('SignatureServiceInterface')

    const signature = await signatureService.signRequest(mintRequest)

    const url = `/api/cards/${mintRequest.id}/mint`

    const requestBody = {
      networkId: mintRequest.networkId,
      owner: mintRequest.account,
      signature: signature,
    }

    const options = {
      method: 'POST',
      body: JSON.stringify(requestBody),
      headers: {
        'Content-Type': 'application/json',
      },
    }

    const response = await fetch(url, options)

    if (!response.ok) {
      const error = await response.json() as APIError

      throw new Error(error.message)
    }

    const mintedCard = await response.json() as MintCardResponseDto

    await this.analyticService.trackProductMinted({
      tokenId: mintedCard.tokenId as string,
      category: 'card',
      collection: mintedCard.collectionName,
      productId: mintedCard.id,
      organizer: mintedCard.organizerName,
      contract: {
        chain: chain.name,
        address: chain.cardContract.address,
      },
    }).catch(
      (exception: unknown) => console.error(exception)
    )
  }
}
